export const LEGAL_CANCELLATION_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Cancellation Policy</h1>
 Refund Eligibility and Procedures
</center>

---

## Cancellation Rights & Guidelines

*Also Referred to as “Widerrufsbelehrung” in German Law*
*Effective as November 19, 2024, and Last updated November 19, 2024*
`;
